<template>
    <w-dialog :dialog-state="dialogState" @handleClose="handleClose" :token='token'>
        <div slot="content" class="download-before">
            <div class="top">
                <p class="title">简历下载</p>
                <i @click="handleClose" class="iconfont iconx" style="font-size: 18px; cursor: pointer"></i>
            </div>
<!--            @click="downloadApp"-->
            <div class="middle" :style="{paddingBottom: type === 5 ? '16px' : '22px'}"  @mousemove="downloadApp(true && type !== 5)" @mouseleave="downloadApp(false)">
                <div class="nav-info" v-if="type !== 3 && type !== 5">
                    <span class="left" v-if="type === 1">
                        你有264位校友已加入超级校友群，加入群聊，大佬在线答疑
                    </span>
                    <span class="left" v-if="type === 4">
                        扫码下载APP，刷校招题目，看大佬笔经、面经
                    </span>
                    <span class="left" v-if="type === 2">
                        试试超级内推：已有2,675 用户通过内推入职
                    </span>
<!--                    <span class="right" >-->
<!--                        查看更多{{typeName[type-1]}}-->
<!--                    </span>-->
                </div>
                <div class="nav-info" v-if="hasOurJob && type === 3">
                    <span class="left">该职位由Leader直招，与你的简历匹配度95%。立即投递，直达面试！</span>
                </div>
                <div class="nav-hr-info" v-if="!hasOurJob && type ===3 && similarList.length">
                    <div class="hr-left">
                        <img class="nav-hr-icon" v-if="similarList[random].hr_avatar" :src="similarList[random].hr_avatar" alt="">
                        <img class="nav-hr-icon" src="https://photo.wondercv.com/image/lusihr/IMG_1195.JPG" alt="">
                        <span class="nav-hr-name" v-if="similarList[random].hr_name">{{similarList[random].hr_name}}</span>
                        <span class="nav-hr-name" v-else>霍女士</span>
                        <span class="nav-hr-text" >我司正在急招工作经验{{similarList[random].display_experience+"的"+similarList[random].job_post}}，诚邀投递</span>
                    </div>
                    <div class="hr-right" @click="positionMore">查看更多职位</div>
                </div>
                <div class="content new-content" v-if="type === 4 && talktoList.length">
                  <div class="bbs">
                    <div class="talk-top" v-if="talktoList[random].user ? true : false">
                      <img class="head-icon" :src="talktoList[random].user.avatar_url">
                      <span class="name">{{talktoList[random].user.username}}</span>
                      <span class="school">{{talktoList[random].user.community_identity ? talktoList[random].user.community_identity : '广州外语外贸大学/2021届'}}</span>
                    </div>
                    <div class="talk-content">
                      <p class="talk-title">{{talktoList[random].title}}</p>
                      <p class="talk-text">{{talktoList[random].content}}</p>
                    </div>
                    <div class="talk-bottom">
                      <div class="btn-talk-bottom">
                        <i class="iconfont iconfenxiang1"></i> 分享
                      </div>
                      <div class="btn-talk-bottom">
                        <i class="iconfont iconpinglun1"></i> 评论
                      </div>
                      <div class="btn-talk-bottom">
                        <i class="iconfont iconweidianzan1"></i> {{talktoList[0].like_count}}
                      </div>
                    </div>
                  </div>
                  <div class="code">
                    <img :src="imgUrl" alt="">
                  </div>
                </div>
                <div class="content new-content" v-if="type === 1">
                    <div class="chat">
                        <img class="chat-icon" src="@/assets/image/joinchat.png" alt="">
                    </div>
                  <div class="code">
                    <img :src="imgUrl" alt="">
                  </div>
                </div>
                <div class="content other" :class="{'new-content': type === 2}"  v-if="type === 2 || type === 3" >
                    <div class="push-in-top" v-if="type === 2" >
                        <div class="push-in-info">
                            <img class="push-icon" src="@/assets/image/chen.jpg" alt="">
                            <div class="hr">
                                <p class="hr-name">陈先生</p>
                                <p class="hr-position">字节跳动 · 产品专家</p>
                            </div>
                        </div>
                        <div class="push-in-bottom">
                            内推码：WX8RFGE
                        </div>
                    </div>
                  <div class="code" v-if="type === 2" >
                    <img :src="imgUrl" alt="">
                  </div>
                    <div class="position" v-if="type === 3 && !hasOurJob && similarList.length" @click="goToDetail(similarList[random].token)">
                        <div class="position-top">
                            <div class="position-top-left">
                                {{similarList[random] && similarList[random].job_post}}
                            </div>
                            <div class="position-top-right">
                                {{similarList[random] && similarList[random].display_salary}}
                            </div>
                        </div>
                        <div class="position-middle" >
                            <div class="through">立即投递</div>
                            <div class="position-item" v-for="(city,index) in similarList[random].city_names" :key="`c-${index}`">
                                <span class="position-middle-item" v-if="index < 1">
                                    {{city}}
                               </span>
                            </div>
                            <div class="position-item" v-if="similarList[random] && similarList[random]['display_experience']">
                                <span class="position-middle-item" >
                                    {{similarList[random]['display_experience']}}
                               </span>
                            </div>
                            <div class="position-item" v-if="similarList[random] && similarList[random]['degree_name']">
                                <span class="position-middle-item" >
                                    {{similarList[random]['degree_name']}}
                               </span>
                            </div>
                            <template v-for="(item,index) in similarList[random].job_tags">
                              <div class="position-item" v-if="similarList[random].job_tags !== null" :key="`i-${index}`">
                                <span class="position-middle-item" v-if="index < 1">
                                  {{item}}
                                </span>
                              </div>
                            </template>
                            
                        </div>
                        <div class="position-bottom">
                            <img class="position-bottom-icon" :src="similarList[random].company_logo" alt="">
                            <span class="position-bottom-name" style="max-width: 40%">{{similarList[random] && similarList[random].company_name}}</span>
                            <span class="leave"></span>
                            <span class="position-bottom-name" style="max-width: 20%">{{similarList[random] && similarList[random].company_industry}}</span>
                            <span class="leave"></span>
                            <span class="position-bottom-name" style="max-width: 20%">{{similarList[random] && similarList[random].company_scale}}</span>
                        </div>
                    </div>
                    <div class="position ourJobs" v-if="type === 3 && hasOurJob && similarList.length" @click="goToDetail(similarList[0].token)">
                        <div class="position-hr">
                            <img src="https://photo.wondercv.com/image/lusihr/IMG_1195.JPG" alt="">
                            <span>霍女士</span>
                        </div>
                        <div class="position-hr-top">
                            <div class="hr-top-left" >
                                {{similarList[0].job_post}}
                            </div>
                            <div class="hr-top-right">
                                {{similarList[0].salary}}
                            </div>
                        </div>
                        <div class="through">立即投递</div>
                        <div class="position-bottom">
                            <img class="position-bottom-icon" :src="similarList[0].company_logo" alt="">
                            <span class="position-bottom-name">{{similarList[0].company_name}}</span>
                            <span class="leave"></span>
                            <span class="position-bottom-name">互联网</span>
                            <span class="leave"></span>
                            <span class="position-bottom-name">20-99人</span>
                        </div>
                    </div>
                </div>
                <div class="content new-content resume-shop" v-if="type === 5" @mouseleave="isShop = false" @mousemove="isShop = true">

                    <img src="https://files.wondercv.com/pc/download/resume-shop.png" width="132" height="132">

                    <div>
                        <div class="shop-title">
                            <span>面试神器：超级简历袋来了！</span>
                            <span>扫码抢购</span>
                        </div>
                        <p class="shop-other">
                            <i>🌟</i>
                            <span>1秒征服面试官，通过率翻倍</span>
                        </p>
                        <p class="shop-other">
                            <i>🌟</i>
                            <span>多夹层分页设计，面试再多公司也不怕</span>
                        </p>
                        <p class="shop-other">
                            <i>🌟</i>
                            <span>给你超多好运，拿下名企高薪Offer</span>
                        </p>
                    </div>
                  <img class="shop-img-code" src="https://files.wondercv.com/pc/download/shop-code.png" alt="">
                </div>
<!--                <div class="appIcon" v-show="isDownloadApp" >-->
<!--                    <p>扫码下载 APP</p>-->
<!--                    <img :src="imgUrl" alt="">-->
<!--                    <div class="point">-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="appIcon" v-show="isShop">-->
<!--                    <p>扫码立即抢购</p>-->
<!--                    <img src="https://files.wondercv.com/pc/download/shop-code.png" alt="">-->
<!--                    <div class="point">-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="bottom">
                <div class="btn" @click="trigger({type:'pdf'})">
                    <i class="iconfont iconbaocunbendi1 iconTop"></i>
                    <span>下载文件</span>
                </div>
                <div class="btn" @click="trigger({type:'img'})">
                    <i class="iconfont iconxiazaitupian iconTop"></i>
                    <span>下载图片</span>
                </div>
                <div class="btn" @click="trigger({type:'merge'})">
                    <i class="iconfont iconshouji iconTop"></i>
                    <span>下载到手机</span>
                </div>
            </div>
        </div>
    </w-dialog>
</template>
<script>
    import WDialog from '@/components/base/dialog';
    import { routerTo } from '@/assets/js/util';
    import { ioMixin } from '@/assets/js/io'
    import api from '@/api'
    import * as cvsV3 from "../../../../api/list/cvsV3";
    export default {
        name: "downloadBefore",
        props: {
            dialogState: {
                type: Boolean,
                default: false
            },
            qrUrl: {
                type: String,
                default: ''
            },
            token: {
                type: String,
                default: ''
            },
            downloadState: {
                type: Boolean,
                default: false
            },
            type: {
                type: Number,
                default: 1  // 1 群聊 2 内推 3 职位 4 讨论
            }
        },
      mixins: [ioMixin],
        data() {
            return {
                typeName: ['群聊', '内推', '职位', '讨论'],
                recommendOurJob: false, // 是否推荐我们自己的职位
                hasOurJob: false,
                similarList: [],
                randomNum: 0, // 随机生成数推荐职位中使用
                isDownloadApp: false, // 下载app二维码
                pushInList: [],  // 内推
                talktoList: [],
                random: 0,
                isShop: false
            }
        },
        created() {
            // this.getJobs()
            this.getPushInInfo()
            this.talkto()
        },
        watch: {
          type: {
            async handler(newVal, oldVal) {
              try {
                if (newVal === 3) {
                  await this.getJobs()
                  this.random = parseInt(Math.random() * this.similarList.length - 1)
                }
              } catch (error) {
                console.log(error)
              }
            }
          }
        },
        computed: {
          imgUrl () {
            if (this.type === 1) {
              return 'https://files.wondercv.com/download-code/editor-download-chat.png'
            } else if (this.type === 2) {
              return 'https://files.wondercv.com/download-code/editor-download-nei.png'
            } else if (this.type === 4) {
              return 'https://files.wondercv.com/download-code/editor-download-community.png'
            } else {
              return 'https://files.wondercv.com/appDownloadIcon.png'
            }
          }
        },
        components: {
            WDialog
        },
        methods: {
            handleClose () {
                this.isDownloadApp = false
                this.$emit('handleClose')
            },
            trigger (params) {
                if (params.type === 'merge') {
                    this.isDownloadApp = true
                } else {
                    this.getPushInInfo()
                    this.$emit('trigger', params)
                }
            },
            // 去职位详情
            goToDetail (token) {
                routerTo(`/jobs/${token}.html`,'_blank')
            },
            // 职位查看更多
            positionMore () {
                routerTo('/jobs/search','_blank')
            },
            // 简历相关职位
            async getJobs (){
                // if (this.recommendOurJob) {
                //     try {
                //         let res = await this.getWondercvJob(this.$route.params.token)
                //         if (res && res.length > 0) {
                //             this.hasOurJob = true
                //             this.similarList = res
                //         }
                //     } catch(err) {
                //         console.log(err)
                //     }
                // }
                if (this.similarList && this.similarList.length) return
                try {
                  // let res = await api.cvsV2.cvsDownloadJobsRecommend({
                  let res = await api.recommend.downloadToJob({
                    size: 6,
                    page: 1,
                    // cv_token: this.$route.params.token
                    resume_token: this.$route.params.token,
                    cv_account_token: this.accountToken.c_t || ''
                  })
                  if (res.code === 1000) {
                    this.similarList = (res && res.data && res.data.jobs) || []
                  }
                } catch (err) {
                  console.log(err)
                  this.similarList = []
                }
            },
            // 讨论
            async talkto () {
                let res = await api.cvsV3.talkto({
                    page: 1,
                    size: 6,
                    exist_title: 1
                })
                if( res.code === 1000 ) {
                    this.talktoList = res.data.news_li
                    console.log('talktoList=>>',this.talktoList)
                }
            },
            // 内推相关
            async getPushInInfo () {
              let res = await api.cvsV3.pushInList({
                  page: 1,
                  size: 6
              })
                if( res.code === 1000 ) {
                    this.pushInList = res.data.recommends
                }
            },
            // 查看是否有Wondercv自己需要推荐的职位
            async getWondercvJob(token) {
                try {
                    if (this.recommendOurJob) {
                        let resumePredictedResultRes = await api.cvsEditor.getCvPredictedResult(token)
                        let resumeCities = false
                        let experience = 0
                        let nodeLv2 = "1000000"
                        if (resumePredictedResultRes && resumePredictedResultRes.code === 1000) {
                            let resumePredictedResult = resumePredictedResultRes.data
                            if (resumePredictedResult.expected_cities.includes("北京") || resumePredictedResult.predict_cities.includes("北京")) {
                                resumeCities = true
                            }
                            nodeLv2 = (resumePredictedResult.result && resumePredictedResult.result.level2_id) || nodeLv2
                            experience = resumePredictedResult.years_of_work_experience || experience
                        } else {
                            return []
                        }
                        let wondercvJobsRes = await api.jobs.getOurCompanyJobs()
                        if (wondercvJobsRes && wondercvJobsRes.code === 1000) {
                            let wondercvJobsData = (wondercvJobsRes.data && wondercvJobsRes.data.jobs) || []
                            return wondercvJobsData.filter(function (item) {
                                if ((nodeLv2.slice(0, 4) === item.profession_id.slice(0, 4))) {
                                    return item
                                }
                            })
                        }
                    } else {
                        return []
                    }
                } catch(err) {
                    console.log(err)
                    return []
                }
            },
            // 下载app二维码查看详情
            downloadApp(bool) {
                if(this.type !== 3)
                this.isDownloadApp = bool
            }
        }
    }
</script>

<style scoped lang="scss">
    @mixin overhide {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .iconTop {
        color: #404040;
        font-size: 18px;
        vertical-align: bottom;
    }
    .download-before {
        width: 680px;
        min-height: 340px;
        background: #FFFFFF;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.13);
        border-radius: 8px;
        padding: 32px 32px 32px 32px;
        box-sizing: border-box;
    }
    .top {
        display: flex;
        justify-content: space-between;
        & .title{
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #404040;
            line-height: 20px;
        }
    }
    .middle {
         margin-top: 16px;
         margin-bottom: 24px;
      //width: 492px;
      width: 100%;
         /*min-height: 180px;*/
         background: #F9F9F9;
         border-radius: 6px;
         box-sizing: border-box;
         padding: 16px 24px 22px 24px;
         position: relative;
         white-space: nowrap;
         //& .other {
         //    background: #FFFFFF;
         //    padding: 16px 24px;
         //}
         & .nav-info {
             display: flex;
             justify-content: space-between;
             margin-bottom: 16px;
             font-size: 14px;
             height: 14px;
             line-height: 14px;
             font-weight: 400;
             & .left {
                 color: #404040;
               font-weight: 500;
               font-size: 16px;
             }
             & .right {
                 cursor: pointer;
                 color: #4183FF;
             }
         }
         & .nav-hr-info {
             display: flex;
             justify-content: space-between;
             height: 20px;
             margin-bottom: 13px;
             overflow: hidden;
             & .hr-left {
                 width: 345px;
             }
             & .hr-right {
                 height: 20px;
                 font-size: 14px;
                 font-weight: 400;
                 color: #4183FF;
                 line-height: 20px;
             }
             .nav-hr-icon {
                 width: 20px;
                 height: 20px;
                 border-radius: 50%;
                 float: left;
             }
             .nav-hr-name {
                 margin-left: 8px;
                 margin-right: 6px;
                 max-width: 60px;
                 overflow: hidden;
                 text-overflow: ellipsis;
                 white-space: nowrap;
                 height: 20px;
                 font-size: 14px;
                 font-weight: 400;
                 color: #404040;
                 line-height: 20px;
                 float: left;
             }
             .nav-hr-text {
                 @include overhide;
                 max-width: 70%;
                 height: 20px;
                 float: left;
                 font-size: 13px;
                 font-weight: 400;
                 color: #404040;
                 line-height: 20px;
             }
         }
      .new-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

         & .content {
           //width: 444px;
           width: 100%;
             //min-height: 112px;
             border-radius: 8px;
             box-sizing: border-box;
             font-weight: 500;
             @include overhide;
             position: relative;
           .code {
             width: 112px;
             height: 112px;
             background-color: #fff;
             display: flex;
             justify-content: center;
             align-items: center;
             border-radius: 8px;
             img {
               width: 96px;
               height: 96px;
             }
           }
           .bbs {
             width: 444px;
             height: 110px;
             & .talk-top {
               display: flex;
               height: 28px;
               line-height: 28px;
               font-size: 14px;
               width: 444px;
               @include overhide;
               & .head-icon{
                 width: 28px;
                 height: 28px;
                 overflow: hidden;
                 border-radius: 50%;
                 vertical-align: middle;
               }
               & .name {
                 color: #404040;
                 margin-left: 8px;
                 margin-right: 10px;
                 font-weight: 500;
                 max-width: 40%;
                 @include overhide;
               }
               & .school {
                 font-weight: 400;
                 color: #9C9C9C;
                 max-width: 40%;
                 @include overhide;
               }
             }
             & .talk-content {
               & .talk-title {
                 height: 16px;
                 font-size: 16px;
                 color: #404040;
                 line-height: 16px;
                 margin-top: 10px;
                 margin-bottom: 6px;
                 width: 430px;
                 @include overhide;
               }
               & .talk-text {
                 height: 20px;
                 width: 444px;
                 @include overhide;
                 font-size: 14px;
                 font-weight: 400;
                 color: #606060;
                 line-height: 20px;
                 margin-bottom: 14px;
               }

             }
             & .talk-bottom {
               display: flex;
               & .btn-talk-bottom {
                 & i {
                   position: relative;
                   top: 1px;
                 }
                 color: #404040;
                 line-height: 14px;
                 height: 14px;
                 margin-right: 24px;
                 font-weight: 400;
               }
             }
           }
             & .push-in-top {
                 //height: 48px;
                 //margin-bottom: 16px;
               box-sizing: border-box;
               padding: 16px 24px;
               width: 444px;
               height: 112px;
               background-color: #fff;
               border-radius: 8px;
                 & .push-in-info {
                     width: 100%;
                     display: flex;
                 }
                 & .push-icon {
                     flex-shrink: 0;
                     width: 48px;
                     height: 48px;
                     vertical-align: center;
                     display: inline-block;
                     border-radius: 50%;
                 }
                 & .hr {
                     margin-top: 3px;
                     margin-left: 12px;

                 }
                 & .hr-name {
                     font-size: 16px;
                     font-weight: 400;
                     color: #404040;
                     margin-bottom: 8px;
                 }
                 & .hr-position {
                     width: 350px;
                     @include overhide;
                     font-size: 18px;
                     font-weight: 500;
                     color: #404040;
                 }
             }
             & .push-in-bottom {
                 width: 390px;
                 margin-top: 16px;
                 font-size: 16px;
                 font-weight: 500;
                 @include overhide;
                 color: #404040;
             }
             & .position {
                 & .through {
                     width: 76px;
                     height: 28px;
                     background: #FF6644;
                     border-radius: 16px;
                     position: absolute;
                     top: 30px;
                     //left: 344px;
                   right: 16px;
                     text-align: center;
                     line-height: 28px;
                     font-size: 14px;
                     font-weight: 400;
                     color: #FFFFFF;
                 }
                 & .position-top {
                     display: flex;
                     height: 18px;
                     font-weight: 500;
                     & .position-top-left {
                         font-size: 18px;
                         color: #404040;
                         line-height: 18px;
                     }
                     & .position-top-right {
                         margin-left: 12px;
                         font-size: 16px;
                         color: #FF6644;
                         line-height: 18px;
                     }
                 }
                 & .position-middle {
                     min-height: 24px;
                     margin-right: -6px;
                     margin-top: 10px;
                     display: flex;
                     margin-bottom: 8px;

                     .position-item {
                         height: 24px;
                         line-height: 24px;
                         text-align: center;
                         border-radius: 4px;
                         background: #F9F9F9;
                         margin-right: 6px;
                         box-sizing: border-box;
                         .position-middle-item {
                             padding: 3px 10px;
                             color: #9C9C9C;
                             font-weight: 400;
                             font-size: 14px;
                         }
                     }
                 }
                 & .position-bottom {
                     display: flex;
                     align-items: center;
                     min-height: 26px;
                     font-size: 14px;
                     font-weight: 400;
                     color: #606060;
                     .leave {
                         display: block;
                         width: 0px;
                         height: 8px;
                         border-left:1px solid #D8D8D8;

                     }
                     box-sizing: border-box;
                     & .position-bottom-name {
                         padding: 6px 8px;
                         @include overhide;
                     }
                     & .position-bottom-icon {
                         width: 26px;
                         height: 26px;
                         border-radius: 4px;
                         border: 1px solid #ECECEC;
                         box-sizing: border-box;
                       object-fit: contain;
                     }
                 }
             }
             & .ourJobs {
                 .position-hr {
                    margin-bottom: 12px;
                    height: 20px;
                    & img {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        margin-right: 10px;
                        display: inline-block;
                    }
                   & span {
                       display: inline-block;
                       height: 20px;
                       font-size: 14px;
                       font-weight: 400;
                       color: #404040;
                       line-height: 20px;
                   }
                }
                & .position-hr-top {
                     height: 18px;
                     line-height: 18px;
                     margin-bottom: 10px;
                     display: flex;
                     .hr-top-left {
                         max-width: 50%;
                         overflow: hidden;
                         white-space: nowrap;
                         text-overflow: ellipsis;
                         font-size: 18px;
                         font-weight: 500;
                         color: #404040;
                         margin-right: 22px;
                     }
                     .hr-top-right {
                         font-size: 16px;
                         font-weight: 500;
                         color: #FF6644;
                     }
                 }
             }
             & .chat {
                 & .chat-icon {
                     width: 444px;
                     height: 111px;
                 }
             }
         }
         & .appIcon {
             position: absolute;
             background-color: #fff;
             top: -13px;
             right: -241px;
             width: 196px;
             height: 205px;
             box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.06);
             box-sizing: border-box;
             padding: 17px 27px 22px 32px;
             border-radius: 4px;
             text-align: center;
             & p {
                 width: 133px;
                 font-size: 14px;
                 font-weight: 400;
                 color: #404040;
                 margin-bottom: 19px;
             }
             & img {
                 width: 133px;
                 height: 133px;
                 padding-left: 2px;
             }
             .point {
                 width: 0px;
                 height: 0px;
                 border-right: 9px solid #fff;
                 border-top: 9px solid transparent;
                 border-bottom: 9px solid transparent;
                 position: absolute;
                 top: 83px;
                 left: -8px;
             }
         }
     }
    .bottom {
        display: flex;
        margin-right: -15px;
        & .btn {
            cursor: pointer;
            line-height: 46px;
            text-align: center;
            margin-right: 15px;
            width: 193px;
            height: 46px;
            border-radius: 4px;
            border: 1px solid #ececec;
            color: #404040;
        }
    }
    .btn:hover {
        border: 1px solid #FF6644;
        color: #FF6644;
    }
    .btn:hover .iconTop {
        color: #FF6644;
    }
    .middle:hover {
        cursor: pointer;
        background-color: #f4f4f4;
    }
    .resume-shop{
        display: flex;
      justify-content: flex-start!important;
        position: relative;
        align-items: center;
        img{
            margin-right: 16px;
        }
      .shop-img-code {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        margin-left: 16px;
        margin-right: 0;
      }
        .shop-title{
            padding-top: 7px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            &>span:first-child{
                font-size: 16px;
                font-weight: 500;
                color: #404040;
                line-height: 18px;
            }
            &>span:last-child{
                width: 76px;
                height: 28px;
                background: #FF6644;
                border-radius: 16px;
                text-align: center;
                line-height: 28px;
                color: #fff;
                font-size: 14px;
                font-weight: 400;
            }
        }
        .shop-other{
            display: flex;
            align-items: center;
            height: 26px;
            font-weight: 400;
            color: #404040;
            i{
                margin-right: 16px;
            }
        }
    }
</style>
